module.exports = __webpack_public_path__ + "a6d01db5b6f27a00e79b3f6a0cc5dd86.png";